import { useEvent } from "shared/lib/useEvent"

import { useTeamListModel } from "features/team-management/ui/team-list/model/useTeamListModel"

import { TeamsOverviewPageModel } from "../types/TeamsOverviewPageModel"

export function useTeamsOverviewPageModel(): TeamsOverviewPageModel {
  const teamListModel = useTeamListModel()
  // const { openOverlay } = useOverlay(PROJECT_TEAM_OVERLAY)

  const handleNewTeam = useEvent(() => {
    // openOverlay({})
  })

  return { teamListModel, onNewTeam: handleNewTeam }
}
